function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Swiper, defaultSwiperSettings } from '../../../src/js/swiper-utils';
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll('.product-slider-block')) {
    var sliders = document.querySelectorAll('.product-slider-block');
    sliders.forEach(function (slider) {
      var _slider$querySelector;

      var large = (_slider$querySelector = slider.querySelector('.product-swiper').classList.contains('product-swiper-large')) !== null && _slider$querySelector !== void 0 ? _slider$querySelector : false;
      var developmentsSlider = new Swiper(slider.querySelector('.product-swiper'), _objectSpread(_objectSpread({}, defaultSwiperSettings('auto', 330, false, false)), {}, {
        spaceBetween: 20,
        slidesPerView: 1.15,
        centeredSlides: false,
        centerInsufficientSlides: false,
        loop: false,
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          640: {
            slidesPerView: large ? 1.4 : 1.7
          },
          768: {
            slidesPerView: large ? 1.8 : 2
          },
          1024: {
            slidesPerView: large ? 2.4 : 3.5
          },
          1280: {
            slidesPerView: large ? 3.2 : 4.5
          },
          1536: {
            slidesPerView: large ? 3.85 : 5.15
          }
        }
      }));
    });
  }
});